import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import AsyncSelect from "react-select/lib/Async";
import { useDebouncedAsyncSelect } from "Utils/Hooks/useDebounce";
const refreshIcon = require("assets/img/icons/refresh.png");

export const FiltrosReajustes = ({
    control,
    getProductos,
    onRefresh,
    resetPage,
}) => {
    const loadProductos = useDebouncedAsyncSelect(function (search) {
        return getProductos({ search: search });
    });

    return (
        <div className="formulario-fields-row align-items-end my-0">
            <div className="formulario-field" style={{ minWidth: "180px" }}>
                <label htmlFor="producto" className="m-0">
                    Tipo de producto
                </label>
                <Controller
                    name="producto"
                    control={control}
                    render={({ field }) => (
                        <AsyncSelect
                            {...field}
                            className="react-select-container"
                            isSearchable
                            isClearable
                            defaultOptions
                            loadOptions={loadProductos}
                            getOptionValue={(option) => option.id}
                            getOptionLabel={(option) => option.nombre}
                            placeholder="Todos"
                            onChange={(option) => {
                                field.onChange(option);
                                resetPage();
                            }}
                        />
                    )}
                />
            </div>
            <div className="formulario-field">
                <label htmlFor="pallet" className="m-0">
                    Pallet
                </label>
                <Controller
                    name="pallet"
                    control={control}
                    render={({ field }) => (
                        <input
                            {...field}
                            type="text"
                            className="form-control"
                            placeholder="No. o identificador"
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                resetPage();
                            }}
                        />
                    )}
                />
            </div>
            <div className="formulario-field">
                <label htmlFor="fecha_inicial" className="m-0">
                    Fecha inicial
                </label>
                <Controller
                    name="fecha_inicial"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                                field.onChange(date);
                                resetPage();
                            }}
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha de inicio"
                            maxDate={control._formValues.fecha_final}
                        />
                    )}
                />
            </div>
            <div className="formulario-field">
                <label htmlFor="fecha_final" className="m-0">
                    Fecha final
                </label>
                <Controller
                    name="fecha_final"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                                field.onChange(date);
                                resetPage();
                            }}
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha final"
                            minDate={control._formValues.fecha_inicial}
                        />
                    )}
                />
            </div>
            <img
                src={refreshIcon}
                alt="Refrescar listado"
                title="Refrescar listado"
                className="action_img mb-1"
                onClick={() => {
                    onRefresh();
                }}
            />
        </div>
    );
};
